import React, { useRef, useState } from 'react'

function TokenomicsOne() {
    const textToCopyRef = useRef(null);
    const [copyMessageVisible, setCopyMessageVisible] = useState(false);

    const handleCopy = () => {
        if (!textToCopyRef.current) {
            console.error('Text input not found!');
            return;
        }

        // Select the text for compatibility
        textToCopyRef.current.select();
        textToCopyRef.current.setSelectionRange(0, 99999);

        // Copy the text to the clipboard
        navigator.clipboard
            .writeText(textToCopyRef.current.value)
            .then(() => {
                // Show copy message
                setCopyMessageVisible(true);
                setTimeout(() => {
                    setCopyMessageVisible(false);
                }, 2000);
            })
            .catch((err) => console.error('Failed to copy text: ', err));
    };
    return (
        <>
            {/* Tokenomics area Start */}
            <section id="tokenomics" className="rts-tokenomics-area rts-section-gap">
                <div className="container">
                    <div className="section-inner">
                        <div className="right-image-area">
                            <img
                                className="wow scaleIn"
                                data-wow-delay=".8s"
                                data-wow-duration="1s"
                                src="assets/images/token/image-01.svg"
                                alt=""
                            />
                            <div className="shape-area">
                                <img
                                    className="wow fadeIn"
                                    data-wow-delay="1s"
                                    data-wow-duration="2s"
                                    src="assets/images/token/coin-01.svg"
                                    alt=""
                                />
                                <img
                                    className="wow fadeIn"
                                    data-wow-delay="1s"
                                    data-wow-duration="2s"
                                    src="assets/images/token/coin-01.svg"
                                    alt=""
                                />
                                <img
                                    className="wow fadeIn"
                                    data-wow-delay="1s"
                                    data-wow-duration="2s"
                                    src="assets/images/token/coin-02.svg"
                                    alt=""
                                />
                                <img
                                    className="wow fadeIn"
                                    data-wow-delay="1s"
                                    data-wow-duration="2s"
                                    src="assets/images/token/leaf-01.svg"
                                    alt=""
                                />
                                <img
                                    className="wow fadeIn"
                                    data-wow-delay="1s"
                                    data-wow-duration="2s"
                                    src="assets/images/token/leaf-01.svg"
                                    alt=""
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="left-side-content">
                                    <div className="section-title-area">
                                        <p
                                            className="sub-title wow fadeInUp"
                                            data-wow-delay=".2s"
                                            data-wow-duration="2s"
                                        >
                                            Tokenomics
                                        </p>
                                        <h2
                                            className="section-title wow fadeInUp"
                                            data-wow-delay=".5s"
                                            data-wow-duration="2s"
                                        >
                                            Our Meme Token omics
                                        </h2>
                                    </div>
                                    <ul className="feature-list mb--40">
                                        <li
                                            className=" wow fadeInLeft"
                                            data-wow-delay=".8s"
                                            data-wow-duration="2s"
                                        >
                                            <img src="assets/images/token/tik.svg" alt="" />
                                            Low transaction fees
                                        </li>
                                        <li
                                            className=" wow fadeInRight"
                                            data-wow-delay=".8s"
                                            data-wow-duration="2s"
                                        >
                                            <img src="assets/images/token/tik.svg" alt="" />
                                            NFT integration opportunities
                                        </li>
                                        <li
                                            className=" wow fadeInLeft"
                                            data-wow-delay=".8s"
                                            data-wow-duration="2s"
                                        >
                                            <img src="assets/images/token/tik.svg" alt="" />
                                            Deflationary supply (if applicable)
                                        </li>
                                        <li
                                            className=" wow fadeInRight"
                                            data-wow-delay=".8s"
                                            data-wow-duration="2s"
                                        >
                                            <img src="assets/images/token/tik.svg" alt="" />
                                            Meme Creator Rewards
                                        </li>
                                    </ul>
                                    <ul className="bottom-feature-list">
                                        <li
                                            className="button with-after wow fadeInUp"
                                            data-wow-delay="1.1s"
                                            data-wow-duration="2s"
                                        >
                                            <div className="d-block rts-btn">
                                                <h4 className="cb">Total Supply</h4>
                                                <p className="cb">10% Billion Tokens</p>
                                            </div>
                                        </li>
                                        <li
                                            className="button with-after wow fadeInUp"
                                            data-wow-delay="1.1s"
                                            data-wow-duration="2s"
                                        >
                                            <div className="d-block rts-btn">
                                                <h4 className="cb">Community Rewards</h4>
                                                <p className="cb">30% Community Rewards</p>
                                            </div>
                                        </li>
                                        <li
                                            className="button with-after wow fadeInUp"
                                            data-wow-delay="1.1s"
                                            data-wow-duration="2s"
                                        >
                                            <div className="d-block rts-btn">
                                                <h4 className="cb">Liquidity Pool</h4>
                                                <p className="cb">5% Billion Tokens</p>
                                            </div>
                                        </li>
                                    </ul>
                                    <div
                                        className="copy-text-area animate__animated animate__fadeInUp"
                                        style={{ animationDelay: '1.4s', animationDuration: '2s' }}
                                    >
                                        <div className="inner">
                                            <div className="input-wrapper with-after">
                                                <input
                                                    type="text"
                                                    id="textToCopy"
                                                    ref={textToCopyRef}
                                                    defaultValue="0xe471der3c127466908c2ccdc43521c8315b87fd369d605"
                                                    readOnly
                                                />
                                            </div>
                                            <div className="button with-after">
                                                <button className="rts-btn bg-white" id="copyButton" onClick={handleCopy}>
                                                    Copy
                                                </button>
                                            </div>
                                        </div>
                                        {copyMessageVisible && (
                                            <p id="copyMessage" className="mt--10" style={{ color: 'green' }}>
                                                Text copied!
                                            </p>
                                        )}
                                    </div>
                                    <div className="coin-area">
                                        <h2
                                            className="title wow fadeInUp"
                                            data-wow-delay="1.6s"
                                            data-wow-duration="2s"
                                        >
                                            Buy Coin now on
                                        </h2>
                                        <ul>
                                            <li
                                                className="wow zoomIn"
                                                data-wow-delay="1.8s"
                                                data-wow-duration="2s"
                                            >
                                                <img src="assets/images/token/bit-coin.svg" alt="" />
                                            </li>
                                            <li
                                                className="wow zoomIn"
                                                data-wow-delay="2s"
                                                data-wow-duration="2s"
                                            >
                                                <img src="assets/images/token/ethereum.svg" alt="" />
                                            </li>
                                            <li
                                                className="wow zoomIn"
                                                data-wow-delay="2.2s"
                                                data-wow-duration="2s"
                                            >
                                                <img src="assets/images/token/binance.svg" alt="" />
                                            </li>
                                            <li
                                                className="wow zoomIn"
                                                data-wow-delay="2.4s"
                                                data-wow-duration="2s"
                                            >
                                                <img src="assets/images/token/solana.svg" alt="" />
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Tokenomics area End */}
        </>

    )
}

export default TokenomicsOne